export const DATA_AUTOMATION_VARIABLES = ['GST', 'PAN', 'EPF', 'MCA', 'DIN', 'LEGAL', 'ADDITIONAL_LEGAL', 'RATINGS', 'INTERNATIONAL', 'XBRL','NEWS','SOCIALMEDIA','STOCK_EXCHANGE', 'LEI', 'IEC', 'UDYAM', 'UDYOG', 'NICCODE_SEARCH', 'GST_ANALYSIS','BANK_STATEMENT_ANALYSIS','ITR_ANALYSIS','RETAIL_BUREAU', 'AML_PEP', 'MCA_DATA_SYNC','SHIPPING'];
export const GST_ANALYSIS_REQUIRED_FIELDS = {
    fromDate: 'fromDate',
    toDate: 'toDate',
    email: 'email'
}

export const NOT_PERMITTED_CRAWLER_TO_RUN=['SHIPPING']
export const GST_ANALYSIS_NOT_REQUIRED_FIELDS = {
    phoneNo: 'phoneNo'
}
export const BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS = {
    BANK_STATEMENT_ANALYSIS: 'BANK_STATEMENT_ANALYSIS',
    bsaEntityType: 'bsaEntityType',
    bsaBankName: 'bsaBankName',
    bsaAccountType: 'bsaAccountType',
    bsaPdf: 'bsaPdf'
}
export const BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS = {
    bsaSanctionLimit: 'bsaSanctionLimit',
    bsaRelatedPartyKeywords: 'bsaRelatedPartyKeywords'
}
export const INDIVIDUAL = "Individual";
export const ENTITY = "Entity";
export const PAN = "PAN";
export const CIN = "CIN";
export const NAME = "NAME";
export const GST = "GST";
export const SHAREHOLDING = "SHAREHOLDING";
export const QUARTERLY = "QUARTERLY";
export const BSE = "BSE";
export const NSE = "NSE";
export const IEC = "IEC";
export const LEI = "LEI";
export const NUMBER = "NUMBER";
export const OTP = "OTP";
export const EMAIL = "EMAIL";
export const ORGANIZATION = "Organization";